import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { TranslateService } from "../../../../common/variables/translate-service";
import { SC_Input } from "../../../../common/input/SC_Input";
import { Material } from "../../../../common/utilities/Material";
import { RouterPathService } from "../../../../../core/common/variables/router-path.service";
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
  FormArray,
  ValidatorFn
} from '@angular/forms';

@Component({
  selector: 'sen-app-trapez-direct',
  templateUrl: './trapez-direct.component.html',
  styleUrls: ['./trapez-direct.component.scss']
})
export class TrapezDirectComponent implements OnInit {
  form: FormGroup;
  @Output() formValid = new EventEmitter;
  rbMaterial = [
    {
      data: Material.STEEL,
      label: this.translate.getLng('MAT_STEEL'),
      min: 0.63,
      max: 2
    },
    {
      data: Material.ALU,
      label: this.translate.getLng('MAT_ALU'),
      min: 0.9,
      max: 5
    }
  ];
  selectedrbMaterial: any;
  nMinHighBeadingDistance: number = 5;
  nMaxHighBeadingDistance: number = 45;
  prevPath: string;
  nextPath: string;

  constructor(public translate: TranslateService, public formBuilder: FormBuilder, private routerPath: RouterPathService, private route: ActivatedRoute,
    private router: Router) {
    this.prevPath = `..${this.routerPath.pathSeperator}${this.routerPath.RPShapeString}`;
    this.nextPath = `..${this.routerPath.pathSeperator}${this.routerPath.RPPanelString}`;
    this.form = this.formBuilder.group({
      thickness: new FormControl(SC_Input.nTrapezSheetThickness, [Validators.required]),
      distance: new FormControl(SC_Input.nHighBeadingDistance, [Validators.required, Validators.min(this.nMinHighBeadingDistance), Validators.max(this.nMaxHighBeadingDistance)]),
      material: new FormControl(null)
    });
    this.form.valueChanges.subscribe(status => { this.formValid.emit(this.form.valid) });
  }

  ngOnInit(): void {
    let m = this.matIndex(SC_Input.iTrapezMaterial);
    this.selectedrbMaterial = this.rbMaterial[m];
    this.form.get('material')?.setValue(this.rbMaterial[m].data);
    this.thicknessForm.setValidators([Validators.min(this.rbMaterial[m].min), Validators.max(this.rbMaterial[m].max)])
  }

  get thicknessForm() {
    return this.form.get('thickness') as FormControl;
  }

  matIndex(mat: number) {
    return this.rbMaterial.findIndex(x => x.data == mat);
  }

  public fetchInput(ind?: any): void {
    let m = this.matIndex(ind.value);
    this.selectedrbMaterial = this.rbMaterial[m];
    this.thicknessForm.setValidators([Validators.min(this.rbMaterial[m].min), Validators.max(this.rbMaterial[m].max)]);
    this.thicknessForm.updateValueAndValidity();
  }

  ngOnDestroy() {
    this.rememberInput();
  }

  rememberInput(): void {
    SC_Input.iTrapezMaterial = this.form.get('material')!.value;
    SC_Input.nTrapezSheetThickness = this.thicknessForm.value;
    SC_Input.nHighBeadingDistance = this.form.get('distance')!.value;
  }

}
